<div
  #wrapper
  libSwipe
  class="notification-wrapper flex relative max-w-[22.5rem] py-2 pl-4 pr-2 bg-grey-100 dark:bg-grey-550 max-sm:border-b sm:border-l overflow-hidden rounded-lg shadow-[0px_4px_25px_0px_rgba(0,0,0,0.5)] transition-transform"
  [class]="type()"
  (mouseenter)="onPause()"
  (mouseleave)="onResume()"
  (swipeLeft)="onSwipe(ESwipeDirection.Left)"
  (swipeRight)="onSwipe(ESwipeDirection.Right)"
>
  <div class="notification-icon flex items-start pt-0.5">
    <i class="{{ icon() }} text-xl/5"></i>
  </div>

  <div class="flex flex-col w-full pl-3 pr-2">
    @let key = 'COMMON.' + (type() | uppercase);
    <div class="font-bold text-base text-grey-600 dark:text-grey-100">{{ key | transloco }}</div>

    <div
      class="font-normal text-grey-400 dark:text-grey-300 text-sm whitespace-pre-line"
      [innerText]="text()"
    ></div>
  </div>

  <i
    class="ph ph-x cursor-pointer text-base/4"
    (click)="close()"
  ></i>

  <!--лоадер-->
  <div
    class="absolute right-0 bottom-0 h-1 bg-green-900 transition-all"
    [style.width]="lifeTimeProgress() + '%'"
  ></div>
</div>
